const routes = [
  {
    path: 'current',
    name: 'auth.current',
    children: [
      {
        path: 'login',
        name: 'current.login',
        component: () =>
          import(
            /* webpackChunkName: "currentAuth" */ '@/modules/auth/current/views/LoginView.vue'
          ),
        meta: {
          hide: true,
          title: 'LOGIN',
        },
      },
      {
        path: 'forgot-password',
        name: 'current.forgot.password',
        component: () =>
          import(
            /* webpackChunkName: "currentAuth" */ '@/modules/auth/current/views/PasswordRecoveryView.vue'
          ),
        meta: {
          hide: true,
          title: 'FORGOT PASSWORD',
        },
      },
      {
        path: 'verify-otp',
        name: 'current.verify.otp',
        component: () =>
          import(
            /* webpackChunkName: "normalAuth" */ '@/modules/auth/current/views/VerifyOtpView.vue'
          ),
        meta: {
          hide: true,
          title: 'ACCOUNT VERIFICATION',
        },
      },
      {
        path: 'reset-password',
        name: 'current.reset.password',
        component: () =>
          import(
            /* webpackChunkName: "currentAuth" */ '@/modules/auth/current/views/ResetPasswordView.vue'
          ),
        meta: {
          hide: true,
          title: 'RESET PASSWORD',
        },
      },
    ],
  },
];

export default routes;
